module.exports = {
    API_TITLE:"南岸网站群管理平台", //项目名称
    testdomainName:"https://api.xuqinsong-art.org.cn/", //测试域名
    domainName:"https://api.xuqinsong-art.org.cn/", //正式域名
    uploadImageApi:"upload/uploadImage", //图片上传API
    interfacePrefix:"", //接口前缀
    port:8036, //本地端口
    assetsPublicPath:"/", //打包后服务器文件路径
    
}


//////////////////
// WEBPACK FOOTER
// ./vue.config.js
// module id = D/cJ
// module chunks = 25